/**
 *  Get the color of the circle based on its index and the active index
 * @param idx index of the dot
 * @param direction direction of movement
 * @param activeIndex index of the active dot
 * @param activeColor color of the active dot
 * @param trailColor color of the trailing dot
 * @param inactiveColor color of the inactive dot
 * @returns color of the dot
 */
export const getCircleColor = (
  idx: number,
  direction: 'right' | 'left',
  activeIndex: number,
  activeColor: string,
  trailColor: string,
  inactiveColor: string
): string => {
  if (idx === activeIndex) return activeColor
  const trailIndex = direction === 'right' ? activeIndex - 1 : activeIndex + 1
  if (idx === trailIndex) return trailColor
  return inactiveColor
}
